module.exports = __webpack_public_path__ + "static/img/pic1.e8c730a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1/pic1.jpg
// module id = cxxg
// module chunks = 1